<template>
  <div class="d-flex align-center ga-2">
    <v-btn
      v-if="
        !isAuthor &&
        [2, 3].includes(documentAgreementSource.statusId) &&
        !currentParticipant?.isAgreed &&
        !currentParticipant?.isRevision
      "
      color="error"
      variant="outlined"
      rounded="lg"
      @click="sendToRevision()">
      Відправити на доопрацювання
    </v-btn>

    <v-btn
      v-if="isAuthor && [1, 2].includes(documentAgreementSource.statusId)"
      color="success"
      rounded="lg"
      @click="
        documentAgreementSource.statusId === 2
          ? returnFromRevision()
          : sendForAgree()
      ">
      Відправити на погодження
    </v-btn>
    <v-btn
      v-if="
        !isAuthor &&
        documentAgreementSource.statusId === 3 &&
        !currentParticipant?.isAgreed &&
        !currentParticipant?.isRevision
      "
      color="success"
      rounded="lg"
      @click="sendForAgree()">
      Погодити
    </v-btn>

    <v-checkbox
      v-if="!isAuthor && documentAgreementSource.statusId === 3"
      :false-value="false"
      :model-value="true"
      :true-value="true"
      color="#35AB8F"
      hide-details
      readonly>
      <template #label>
        <span class="checkbox-label"> Погоджено </span>
      </template>
    </v-checkbox>

    <v-btn
      v-if="
        isAuthor &&
        (documentAgreementSource.statusId === 2 ||
          (documentAgreementSource.statusId === 3 && !hasAgreedUsers))
      "
      color="error"
      variant="outlined"
      rounded="lg"
      @click="breakAgreement()">
      Зупинити погодження
    </v-btn>
  </div>
</template>

<script lang="ts">
import { useDocumentAgreement } from '../documentAgreement'
import { computed } from 'vue'
import { openDialog } from '@/dialog'
import {
  documentAgreementApprove,
  documentAgreementBreak,
  documentAgreementReturnFromRevision,
  documentAgreementRevision,
} from '@/requests/documentAgreement'
import { setSnackbar } from 'best-modules/plugins'
import { useCan } from '@/composables/useCan'

export default {
  name: 'Agreement',
  setup() {
    const {
      documentAgreementId,
      documentAgreementSource,
      participants,
      userId,
      isAuthor,
      getParticipants,
    } = useDocumentAgreement()
    const { can } = useCan()

    const hasAgreedUsers = computed(() => {
      return participants.value
        ?.filter(a => a.userId !== userId.value)
        .reduce((acc, cur) => acc || cur.isAgreed, false)
    })

    const currentParticipant = computed(() => {
      return participants.value.find(p => p.userId === userId.value)
    })

    const sendToRevision = () => {
      can('document-agreements.revision', () => {
        openDialog({
          name: 'Textarea',
          dialogData: {
            dialogTitle: 'Доопрацювання',
            placeholder: 'Причина',
          },
          params: {
            cb: async text => {
              const data = await documentAgreementRevision(
                documentAgreementId.value,
                { text }
              )
              Object.assign(documentAgreementSource, data)
              await getParticipants()
              setSnackbar({ text: 'Документ відправлено на доопрацювання' })
            },
          },
        })
      })
    }

    const breakAgreement = () => {
      can('document-agreements.break', () => {
        openDialog({
          name: 'Textarea',
          dialogData: {
            dialogTitle: 'Доопрацювання',
            placeholder: 'Причина',
          },
          params: {
            cb: async text => {
              const data = await documentAgreementBreak(
                documentAgreementId.value,
                { text }
              )
              Object.assign(documentAgreementSource, data)
              await getParticipants()
              setSnackbar({ text: 'Документ відправлено на доопрацювання' })
            },
          },
        })
      })
    }

    const returnFromRevision = () => {
      can('document-agreements.revision', () => {
        openDialog({
          name: 'Textarea',
          dialogData: {
            placeholder: 'Доопрацьовано',
            dialogTitle: 'Доопрацювання',
          },
          params: {
            cb: async text => {
              const data = await documentAgreementReturnFromRevision(
                documentAgreementId.value,
                { text }
              )
              setSnackbar({
                text: 'Документ відправлено на погодження',
              })
              Object.assign(documentAgreementSource, data)

              await getParticipants()
            },
          },
        })
      })
    }

    const sendForAgree = () => {
      can('document-agreements.approve', async () => {
        const data = await documentAgreementApprove(documentAgreementId.value)
        setSnackbar({
          text: isAuthor.value
            ? 'Документ відправлено на погодження'
            : 'Документ погоджено',
        })
        Object.assign(documentAgreementSource, data)

        await getParticipants()
      })
    }

    return {
      documentAgreementSource,
      hasAgreedUsers,
      isAuthor,
      currentParticipant,
      sendToRevision,
      breakAgreement,
      returnFromRevision,
      sendForAgree,
    }
  },
}
</script>

<style scoped lang="scss"></style>
